import Core from '_abstracts/core'
import Tracker from './tracker'

Core.Tasks.add(['user', 'content'], () => {
    new Tracker()
})
